import $ from 'jquery';
import ajax from 'util/ajax';
import * as deferred from 'util/deferred';
import { commaFormat } from 'util/global';
import * as latex from 'util/latex';

/** @module */
const notifications = {};

/**
 * Header count element
 * @type {JQuery}
 */
let $count = null;

/**
 * Master notification count
 * @type {Number}
 */
let notifCount = 0;

/** @type {String} */
const oldPageTitle = document.title;

/**
 * Insert a notification count to the beginning of the page title
 * @param {Number} count
 */
var updatePageTitle = function (count) {
  document.title = (count ? '(' + count + ') ' : '') + oldPageTitle; // (N) title
};

/**
 * Update the header count if it exists and the new count is different from the existing count
 * @param {Number} count
 */
function updateCount(count) {
  if ($count !== null && count !== notifCount) {
    $count.text(commaFormat(count));

    // was 0
    if (notifCount === 0) {
      $count.removeClass('hide');
      // is now 0
    } else if (count === 0) {
      $count.addClass('hide');
    }

    // if count increased, show header, make icon wiggle
    if (notifCount < count) {
      $count.parents('#header').removeClass('short');
      $count.addClass('wiggle-more');
    }

    updatePageTitle(count);

    notifCount = count;
  }
}

/**
 * Reload the component when opening the dropdown
 * @param {JQuery} $dropdown
 */
notifications.dropdownHandler = function ($dropdown) {
  var $cmp = $dropdown.find('.cmp-deferred'),
    $parent = $cmp.parent(),
    $clone = $cmp.clone(),
    loaded = false;

  $dropdown.on('open', () => {
    if (loaded) {
      $parent.html($cmp);
      deferred.load($clone);
    } else {
      deferred.load($cmp);
      loaded = true;
    }

    // stop wiggling when the menu opens
    if ($count.length) {
      $count.removeClass('wiggle-more');
    }
  });

  $dropdown.find('.dropdown-menu').on('click', function (e) {
    e.stopPropagation();
  });
};

/**
 * Show/hide dismissing notifications button, refreshes component
 * @param {JQuery} $link
 */
notifications.toggleDismissed = function ($link) {
  $link.on('click', function (e) {
    e.preventDefault();
    var data = $link.data();
    $link.addClass('dim');
    ajax(data.pageKey).get($link.attr('href'), {
      component_key: data.componentKey,
    });
  });
};

/**
 * Unread notifications badge in header, polls for updated count
 * @param {JQuery} $element
 */
notifications.unreadCount = function ($element) {
  $count = $element;
  notifCount = parseInt($count.text().replace(/,/g, ''), 10);

  updatePageTitle(notifCount);

  if (data && data.debug) {
    return;
  }

  var data = $count.data(),
    counter = 0,
    f = function (x) {
      // 100x^2 + 500x + 5000
      return 100 * Math.pow(x, 2) + 500 * x + 5000;
    };

  var poll = function () {
    var last_notif_count_timeout;
    $.get(data.url).then(function (response) {
      if ('num_notifications' in response) {
        updateCount(response.num_notifications);
      } else if ('logged_out' in response) {
        clearTimeout(last_notif_count_timeout);
      }
    });
    last_notif_count_timeout = setTimeout(poll, f(counter));
    counter++;
  };
  poll();
};

/**
 * Controller to update the count in the header. Called when the notification list updates
 * (when opening or after dismissing a notification)
 * @param {JQuery} $container
 */
notifications.updateCount = function ($container) {
  updateCount($container.data('notif-count'));
  $('.dropdown.hdr-settings').trigger('update');
};

// update latex when notifications load
window.vkey = window.vkey || {};
window.vkey.notifications_page = (action, actionKey) => {
  // change &amp;copy; to &copy;
  action.new_html = action.new_html.replace(/&amp;(.*?);/g, '&$1;');
  const $root = window.vkey.handle(action, actionKey);
  latex.updateLatex($root);
};

module.exports = notifications;
